<template>
  <v-btn
    class="newton-button"
    rounded
    depressed
    @click="openAssistant"
  >
    <v-icon
      left
      small
    >
      mdi-star-four-points
    </v-icon>

    Newton AI
  </v-btn>
</template>

<script>
import assistantService from '@/ai/services/AssistantService'

export default {
  name: 'NewtonButton',

  methods: {
    openAssistant () {
      assistantService.openSidebar()
    }
  }
}
</script>

<style scoped>
.newton-button {
  min-width: 128px !important;
  height: 36px !important;
  padding: 0 18px !important;

  background-color: #93DE94 !important;
  color: #041F30 !important;

  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;

  box-shadow: none !important;
}

.newton-button:hover {
  background-color: #77E47B !important;
}

.newton-button ::v-deep .v-icon {
  color: #041F30 !important;
}
</style>
